import { client } from "../../../../Infrastructure/agent";

export const ProductionDashboardService = {
  getproductiondashboardData: () =>
    client.get("/ProductionDashboard/GetProductionDashboardData"),
};

